import { render, staticRenderFns } from "./TotalpaydetailReport.vue?vue&type=template&id=6a852f7a"
import script from "./TotalpaydetailReport.vue?vue&type=script&lang=js"
export * from "./TotalpaydetailReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports